import { useEffect, useState } from 'react';
import { getScreenSize } from 'forms-utils-lib/utils/getScreenSize';
import { SIZES, INITIAL_BREAKPOINTS } from 'forms-utils-lib/constants/screen';

export function useWindowSize(breakpoints = INITIAL_BREAKPOINTS) {
  const [currentSize, setCurrentSize] = useState(SIZES.DESKTOP_LG);

  useEffect(() => {
    const handleResize = (e: Event): void => {
      e.preventDefault();
      const size = getScreenSize(breakpoints)(window.innerWidth);
      setCurrentSize(size);
    };
    window.addEventListener('resize', handleResize);
  });

  useEffect(() => {
    // eslint-disable-next-line react-hooks/set-state-in-effect
    setCurrentSize(getScreenSize(breakpoints)(window.innerWidth));
  }, []); // eslint-disable-line react-hooks/exhaustive-deps

  return currentSize;
}
